import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { useLogout } from "../../common/hook";
import { hideConfirm, showConfirm } from "../../../reducer/confirmSlice";

const Wrap = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    
    > p {
        margin: 0 16px;
    }
    
    .btn {
        text-decoration: none;
    }
    .btn ~ .btn {
        margin-left: 8px;
    }

    .dropdown {
        position: relative;
        outline: none;
        &:hover {
            .dropdown-menu {
                display: block;
            }
        }
        .dropdown-menu {
            display: none;
            inset: -10px 0 auto auto !important;
            transform: translateY(55%) !important;
            margin: 0;
        }
    }
`;
export default function UserToolBox() {
    const dispatch = useDispatch();
    const loginInfo = useSelector(state => state.login);
    const logout = useLogout();
    return (
        <Wrap>
            {
            loginInfo.header &&
            <>
            <div className="d-flex align-items-center gap-2">

                <div className="d-flex align-items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6"/>
                    </svg>
                    <span className="fw-bold me-1">{loginInfo.header.adminName ? loginInfo.header.adminName : ""}</span> 님
                </div>
            </div>

            <Button variant="ghost-secondary" className="ms-5 d-flex align-items-center gap-2"
                    onClick={() => {
                        dispatch(showConfirm({
                            msg: "로그아웃 하시겠어요?",
                            func: () => {
                                logout.refetch();
                                sessionStorage.removeItem("isAuthenticated");
                                dispatch(hideConfirm());
                            }
                        }))
                    }}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M6 12.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-1 0v-2A1.5 1.5 0 0 1 6.5 2h8A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 12.5v-2a.5.5 0 0 1 1 0z"/>
                    <path fillRule="evenodd" d="M.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L1.707 7.5H10.5a.5.5 0 0 1 0 1H1.707l2.147 2.146a.5.5 0 0 1-.708.708z"/>
                </svg>
                로그아웃
            </Button>
            </>
            }
        </Wrap>
    );
}